module.exports = __webpack_public_path__ + "img/dropdown-arrow-white.7d95f72c.svg";